<template>
  <div class="reset">
    <h2>Reset Password</h2>

    <div class="reset-wrap">
      <table>
        <tr>
          <th aria-label="userPW">New Password</th>
          <td>
            <input type="password"
                   name="userPW"
                   aria-labelledby="userPW"
                   v-model="model.newPassword" />
            <p class="description">
              Please enter a password combination of alphabet, numeric, special character with more than 8 characters long. More than 4 consecutive characters are not allowed.
            </p>
            <strong class="wrong"
                    v-if="errors.newPassword">* {{ $t(errors.newPassword) }}</strong>
            <strong class="wrong"
                    v-if="errors.noUser">* {{ $t(errors.noUser) }}</strong>
          </td>
        </tr>
        <tr>
          <th aria-label="userPW2">Confirm Password</th>
          <td>
            <input type="password"
                   name="userPW2"
                   aria-labelledby="userPW2"
                   v-model="model.newPasswordConfirm" />
            <strong class="wrong"
                    v-if="errors.newPasswordConfirm">* {{ $t(errors.newPasswordConfirm) }}</strong>
          </td>
        </tr>
      </table>

      <div class="btns">
        <p>
          <button type="button"
                  class="btn_2"
                  @click="onPasswordUpdateClick">Reset Password</button>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import accountApi from '@/api/account'
import modalEvent from '@/lib/modal-event'
import ajaxHandlerMixin from '@/mixins/ajax-handler'

export default {
  name: 'ResetPassword',
  mixins: [ajaxHandlerMixin],
  data () {
    return {
      errors: {},
      model: {
        email: null,
        newPassword: null,
        newPasswordConfirm: null,
        token: null
      }
    }
  },
  created () {
    this.model.token = this.$route.params.token
    accountApi.emailFromToken({ token: this.model.token }).then(response => {
      this.model.email = response.data.email
    })
  },
  methods: {
    onPasswordUpdateClick () {
      this.errors = {}
      accountApi.updatePassword(this.model).then(response => {
        return modalEvent.openToast('resetPassword.passwordChanged')
      }).then(() => {
        this.$router.replace({ name: 'SignIn' })
      }).catch(this.handleAjaxError)
    }
  },
  beforeRouteEnter (to, from, next) {
    const token = to.params.token

    if (!token || token.length !== 32) {
      // TO-DO: 404 page로 이동
      alert(this.$t('system.wrongApproach'))
    }
    next()
  }
}
</script>

<style lang="scss" scoped>
.reset {
  width: 1194px;
  padding: 0 15px;
  margin: 15px auto 0;

  h2 {
    font-size: 30px;
    font-weight: 600;
    color: #151515;
    padding: 40px 0 13px;
    display: inline-block;
    margin: 0 10px;
  }

  .reset-wrap {
    border-radius: 10px;
    box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);
    background-color: #ffffff;
    padding: 20px 20px 50px;
  }

  .txt {
    margin: 30px auto 40px;
    color: #666666;
    text-align: center;
  }

  table {
    width: auto;
    margin: 30px auto 10px;
  }

  th {
    vertical-align: top;
    line-height: 36px;
    color: #666666;
    width: 200px;
    padding-left: 20px;
  }

  td {
    position: relative;
    padding-bottom: 40px;

    input {
      width: 300px;
    }

    .description {
      display: block;
      margin: 5px 5px 0;
      font-size: 12px;
      color: #999999;
      width: 300px;
    }

    .wrong {
      position: absolute;
      left: 0;
      bottom: 15px;
      font-size: 12px;
      font-weight: normal;
      color: #ec0047;
      white-space: nowrap;
    }
  }

  .btns {
    text-align: center;

    p:last-child {
      margin-top: 30px;
      font-size: 14px;

      span {
        cursor: pointer;
        color: #ec0047;
      }
    }
  }

  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    &::-ms-expand { /* for IE */
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/guest/ResetPassword.vue